
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ballistic-chart",
      function () {
        return require("private-next-pages/ballistic-chart/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ballistic-chart"])
      });
    }
  